import { useQuery } from 'react-query';
import { getMyChallenges, getPracticeSessionQuestionById, getPrepePlanById } from 'src/apis/prepPlan';
import { GetMyChallengesAPIResponse, GetPrepPlanByIdAPIResponse, GetPrepPlanPracticeSessionAPIResponse } from 'types';

export const useGetPracticeSessionQuestionById = (
	assessQuestionId: string,
	questionId: string,
	onComplete: (data: GetPrepPlanPracticeSessionAPIResponse) => void,
) => {
	return useQuery({
		queryKey: ['getPracticeSessionQuestionById', assessQuestionId, questionId],
		queryFn: async () =>
			(await getPracticeSessionQuestionById(assessQuestionId, questionId)) as GetPrepPlanPracticeSessionAPIResponse,
		staleTime: 0,
		enabled: !!assessQuestionId,
		onSuccess(data) {
			onComplete(data);
		},
		refetchOnMount: true,
	});
};

export const useGetPrepePlanById = (args: {
	isJobSeekerLoggedIn: boolean;
	id?: string;
	onComplete?: (data: GetPrepPlanByIdAPIResponse) => void;
	handleError?: () => void;
}) => {
	const { isJobSeekerLoggedIn, id, onComplete, handleError } = args;
	return useQuery({
		queryKey: ['getPrepePlanById', id],
		queryFn: async () => (await getPrepePlanById(id)) as GetPrepPlanByIdAPIResponse,
		staleTime: 0,
		enabled: isJobSeekerLoggedIn,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};

export const useGetMyChallenges = (
	onComplete?: (data: GetMyChallengesAPIResponse) => void,
	handleError?: () => void,
) => {
	return useQuery({
		queryKey: ['getMyChallenges'],
		queryFn: async () => (await getMyChallenges()) as GetMyChallengesAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};
